import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { getLaenderCodes } from "../constants"
import { EventBus } from "../eventbus"
import { emitRegionChange, useStoreRechnung } from "../store"

interface RechnungsstellerViewProps {
    basePath: string
}

export function RechnungsstellerView({ basePath }: RechnungsstellerViewProps) {
    const laenderOptions = getLaenderCodes()
    const { t } = useTranslation()
    const { rechnungssteller } = useStoreRechnung("rechnungssteller")

    const { rechnungssteller: person } = rechnungssteller
    const onChange = useCallback<(element: string) => (value: unknown) => void>(
        (element: string) => (value: unknown) => {
            EventBus.instance.emit("changeProperty", `${basePath}.${element}`, value)
            emitRegionChange("rechnungssteller")
        },
        [basePath],
    )

    return (
        <div>
            <Components.Collapsible title={t("rechnung.rechnungssteller.title")} collapsed={false}>
                <Components.FormGroup label={t("rechnung.rechnungssteller.unternehmen.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.unternehmen.placeholder")}
                        onChange={onChange("rechnungssteller.unternehmen")}
                        value={person.unternehmen}
                    />
                </Components.FormGroup>
                <Components.FormGroup label={t("rechnung.rechnungssteller.abweichenderHandelsname.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.abweichenderHandelsname.placeholder")}
                        onChange={onChange("rechnungssteller.abweichenderHandelsname")}
                        value={person.abweichenderHandelsname}
                    />
                </Components.FormGroup>
                <Components.FormGroup label={t("rechnung.rechnungssteller.anschrift.strasse1.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.anschrift.strasse1.placeholder")}
                        onChange={onChange("rechnungssteller.anschrift.strasse1")}
                        value={person.anschrift.strasse1}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungssteller.anschrift.strasse2.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.anschrift.strasse2.placeholder")}
                        onChange={onChange("rechnungssteller.anschrift.strasse2")}
                        value={person.anschrift.strasse2}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungssteller.anschrift.strasse3.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.anschrift.strasse3.placeholder")}
                        onChange={onChange("rechnungssteller.anschrift.strasse3")}
                        value={person.anschrift.strasse3}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungssteller.anschrift.ort.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.anschrift.ort.placeholder")}
                        onChange={onChange("rechnungssteller.anschrift.ort")}
                        value={person.anschrift.ort}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungssteller.anschrift.plz.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.anschrift.plz.placeholder")}
                        onChange={onChange("rechnungssteller.anschrift.plz")}
                        value={person.anschrift.plz}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungssteller.anschrift.land.label")}>
                    <Components.MultiSelect
                        placeholder={t("rechnung.rechnungssteller.anschrift.land.placeholder")}
                        onChange={onChange("rechnungssteller.anschrift.land")}
                        value={laenderOptions.find((o) => o.value === person.anschrift.land)}
                        options={laenderOptions}
                    />
                </Components.FormGroup>
                <Components.FormGroup label={t("rechnung.rechnungssteller.eindeutigeKennung.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.eindeutigeKennung.placeholder")}
                        onChange={onChange("rechnungssteller.eindeutigeKennung")}
                        value={person.eindeutigeKennung}
                    />
                </Components.FormGroup>
                <Components.FormGroup label={t("rechnung.rechnungssteller.handelsregisterNr.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.handelsregisterNr.placeholder")}
                        onChange={onChange("rechnungssteller.handelsregisterNr")}
                        value={person.handelsregisterNr}
                    />
                </Components.FormGroup>
                <Components.FormGroup label={t("rechnung.rechnungssteller.umsatzsteuerId.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.umsatzsteuerId.placeholder")}
                        onChange={onChange("rechnungssteller.umsatzsteuerId")}
                        value={person.umsatzsteuerId}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungssteller.steuernummer.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.steuernummer.placeholder")}
                        onChange={onChange("steuernummer")}
                        value={rechnungssteller.steuernummer}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungssteller.rechtlicheInformationen.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.rechtlicheInformationen.placeholder")}
                        onChange={onChange("rechtlicheInformationen")}
                        value={rechnungssteller.rechtlicheInformationen}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.rechnungssteller.eRechnungsAdresse.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.rechnungssteller.eRechnungsAdresse.placeholder")}
                        onChange={onChange("rechnungssteller.eRechnungsAdresse")}
                        value={person.eRechnungsAdresse}
                    />
                </Components.FormGroup>
            </Components.Collapsible>
        </div>
    )
}
